import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const ContractorIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  function ContractorIcon(props, ref) {
    const { size = 24, className, ...rest } = props;
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        aria-label="Contractor Icon"
        viewBox="0 0 17 16"
        fill="none"
        className={className}
        {...rest}
      >
        <path
          d="M1.83325 14.0002C1.83333 13.1608 2.03151 12.3333 2.41169 11.585C2.79186 10.8367 3.3433 10.1886 4.02113 9.69361C4.69897 9.19858 5.48408 8.87053 6.31261 8.73613C7.14114 8.60173 7.98969 8.66479 8.78925 8.92016M10.4999 5.33333C10.4999 7.17428 9.00753 8.66667 7.16659 8.66667C5.32564 8.66667 3.83325 7.17428 3.83325 5.33333C3.83325 3.49238 5.32564 2 7.16659 2C9.00753 2 10.4999 3.49238 10.4999 5.33333Z"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#646467"
        />
        <path
          d="M12.7522 9.2356H11.4795C11.4795 9.2356 11.1016 9.32925 10.9652 9.49595C10.8288 9.66264 10.7522 9.88874 10.7522 10.1245V13.3467C10.7522 13.5825 10.8288 13.8085 10.9652 13.9752C11.1016 14.1419 11.2866 14.2356 11.4795 14.2356H13.978C14.1833 14.2356 14.3803 14.1419 14.5254 13.9752C14.6706 13.8085 14.7522 13.5825 14.7522 13.3467V10.1245C14.7522 9.88874 14.6706 9.66264 14.5254 9.49595C14.3803 9.32925 14.1833 9.2356 13.978 9.2356H12.6232"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#646467"
        />
      </svg>
    );
  },
);
